export default {
  viewBox: "0 0 24 24",
  html: "<path fill-rule=\"evenodd\" d=\"M4 13H1v-2h3zm.004 0H8v2l4-3-4-3v2H4.006l.004-7c0-1.1.89-2 1.99-2h8l6 6v12c0 1.1-.9 2-2 2H5.99C4.89 22 4 21.1 4 20zM13 3.5V9h5.5z\"/>"
};